export const GET_FIRST_COMPARISON_LOG = "GET_FIRST_COMPARISON_LOG";
export const GET_SECOND_COMPARISON_LOG = "GET_SECOND_COMPARISON_LOG";
export const GET_FIRST_COMPARISON_CALCULATIONS = "GET_FIRST_COMPARISON_CALCULATIONS";
export const GET_SECOND_COMPARISON_CALCULATIONS = "GET_SECOND_COMPARISON_CALCULATIONS";
export const GET_COMPARISON_NET = "GET_COMPARISON_NET";